{
  "AGENT_MGMT": {
    "HEADER": "Agenti",
    "HEADER_BTN_TXT": "Dodaj agenta",
    "LOADING": "Dohvaćanje popisa agenata",
    "DESCRIPTION": "Agent je član vašeg tima korisničke podrške koji može pregledavati poruke korisnika i odgovarati na njih. Popis u nastavku prikazuje sve agente na vašem računu.",
    "LEARN_MORE": "Saznajte više o korisničkim ulogama",
    "AGENT_TYPES": {
      "ADMINISTRATOR": "Administrator",
      "AGENT": "Agent"
    },
    "TABS": {
      "ACTIVE": "Aktivni",
      "DEACTIVATED": "Deaktivirani"
    },
    "DISCONNECT_PHONE": {
      "BUTTON_TEXT": "Odspoji telefon",
      "API": {
        "SUCCESS_MESSAGE": "Telefon agenta uspješno odspojen",
        "ERROR_MESSAGE": "Nije moguće odspojiti telefon agenta, pokušajte kasnije"
      }
    },
    "REACTIVATE": {
      "BUTTON_TEXT": "Reaktiviraj",
      "API": {
        "SUCCESS_MESSAGE": "Agent uspješno reaktiviran",
        "ERROR_MESSAGE": "Nije moguće reaktivirati agenta, pokušajte kasnije"
      },
      "CONFIRM": {
        "TITLE": "Potvrdi reaktivaciju",
        "MESSAGE": "Jeste li sigurni da želite reaktivirati ",
        "YES": "Da, reaktiviraj ",
        "NO": "Ne, odustani "
      }
    },
    "LIST": {
      "404": "Na ovom računu nema agenata",
      "TITLE": "Upravljajte agentima u svom timu",
      "DESC": "Možete dodavati agente u svoj tim i uklanjati ih iz njega.",
      "NAME": "Ime",
      "EMAIL": "E-pošta",
      "STATUS": "Status",
      "ACTIONS": "Radnje",
      "VERIFIED": "Potvrđen",
      "VERIFICATION_PENDING": "Potvrda na čekanju",
      "API_ALLOWED": "Pristup API-ju omogućen",
      "DEACTIVATED_ON": "Deaktiviran dana",
      "AVAILABLE_CUSTOM_ROLE": "Dostupna dopuštenja prilagođene uloge"
    },
    "ADD": {
      "TITLE": "Dodaj agenta u svoj tim",
      "DESC": "Možete dodati osobe koje će pružati podršku u vašim sandučićima.",
      "CANCEL_BUTTON_TEXT": "Odustani",
      "FORM": {
        "NAME": {
          "LABEL": "Ime agenta",
          "PLACEHOLDER": "Unesite ime agenta"
        },
        "AGENT_TYPE": {
          "LABEL": "Uloga",
          "PLACEHOLDER": "Odaberite ulogu",
          "ERROR": "Uloga je obavezna"
        },
        "EMAIL": {
          "LABEL": "Adresa e-pošte",
          "PLACEHOLDER": "Unesite adresu e-pošte agenta"
        },
        "SUBMIT": "Dodaj agenta"
      },
      "API": {
        "SUCCESS_MESSAGE": "Uspješno dodan agent",
        "EXIST_MESSAGE": "Adresa e-pošte agenta već se koristi. Pokušajte s drugom adresom e-pošte",
        "ERROR_MESSAGE": "Nije moguće povezati se s poslužiteljem. Pokušajte ponovno kasnije"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Izbriši",
      "API": {
        "SUCCESS_MESSAGE": "Agent uspješno izbrisan",
        "ERROR_MESSAGE": "Nije moguće povezati se s poslužiteljem. Pokušajte ponovno kasnije"
      },
      "CONFIRM": {
        "TITLE": "Potvrdi brisanje",
        "MESSAGE": "Are you sure to delete ",
        "DESCRIPTION": "Agent će biti odmah odjavljen, uklonjen iz svih timova i sandučića te više neće moći pristupati ovom računu.",
        "YES": "Da, izbriši",
        "NO": "Ne, zadrži"
      }
    },
    "EDIT": {
      "TITLE": "Uredi agenta",
      "FORM": {
        "NAME": {
          "LABEL": "Ime agenta",
          "PLACEHOLDER": "Unesite ime agenta"
        },
        "AGENT_TYPE": {
          "LABEL": "Uloga",
          "PLACEHOLDER": "Molimo odaberite ulogu",
          "ERROR": "Potrebno je unijeti ulogu"
        },
        "EMAIL": {
          "LABEL": "Adresa e-pošte",
          "PLACEHOLDER": "Unesite adresu e-pošte agenta"
        },
        "AGENT_AVAILABILITY": {
          "LABEL": "Raspoloživost",
          "PLACEHOLDER": "Izaberi status raspoloživosti",
          "ERROR": "Potrebna je raspoloživost"
        },
        "API_ACCESS": {
          "LABEL": "Omogući pristup API-ju",
          "HELP": "Pristup API-ju je prema zadanim postavkama onemogućen. Njegovim uključivanjem osobni API ključ ovog agenta može se koristiti u svim računima kojima agent pripada. To ne utječe na prijavu na kontrolnu ploču."
        },
        "SUBMIT": "Uredi agenta"
      },
      "BUTTON_TEXT": "Uredi",
      "CANCEL_BUTTON_TEXT": "Odustani",
      "API": {
        "SUCCESS_MESSAGE": "Agent uspješno ažuriran",
        "ERROR_MESSAGE": "Could not connect to Woot Server, Please try again later"
      },
      "PASSWORD_RESET": {
        "ADMIN_RESET_BUTTON": "Ponovno postvljanje lozinke",
        "ADMIN_SUCCESS_MESSAGE": "Agentu je poslana e-poruka s uputama za ponovno postavljanje lozinke",
        "SUCCESS_MESSAGE": "Lozinka agenta uspješno je ponovno postavljena",
        "ERROR_MESSAGE": "Nije moguće povezati se s poslužiteljem. Pokušajte ponovno kasnije"
      }
    },
    "SEARCH": {
      "NO_RESULTS": "Nema rezultata."
    },
    "MULTI_SELECTOR": {
      "PLACEHOLDER": "Nijedan",
      "TITLE": {
        "AGENT": "Odaberite agenta",
        "TEAM": "Odaberite tim"
      },
      "LIST": {
        "NONE": "Nijedno"
      },
      "SEARCH": {
        "NO_RESULTS": {
          "AGENT": "Nema pronađenih agenata",
          "TEAM": "Nema pronađenih timova"
        },
        "PLACEHOLDER": {
          "AGENT": "Pretraži agente",
          "TEAM": "Pretraži timove",
          "INPUT": "Pretraga agenata"
        }
      }
    }
  }
}
